import React, { Component } from "react";
import UserThumb from "../../assets/user-thumb.png";
import voiceStore from "../../stores/voiceStore";
import moment from "moment";
import Rating from "react-rating";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { Bars } from "react-loader-spinner";
import { LuPause, LuPlay, LuPlaySquare } from "react-icons/lu";

export default class AddNewTalentStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentPlayingIndex: null,
    };
    this.audioRefs = {};
  }

  calculateAge = (date) => {
    const birthDate = moment(date);
    const today = moment();
    return today.diff(birthDate, "years");
  };
  handlePlayPause = (index) => {
    const audioElement = this.audioRefs[index];

    if (
      this.state.currentPlayingIndex !== null &&
      this.state.currentPlayingIndex !== index
    ) {
      const otherAudio = this.audioRefs[this.state.currentPlayingIndex];
      otherAudio.pause();
    }

    if (audioElement.paused) {
      audioElement.play();
      this.setState({ currentPlayingIndex: index });
    } else {
      audioElement.pause();
      this.setState({ currentPlayingIndex: null });
    }
  };
  render() {
    const { loading } = this.state;
    return (
      <div className="flex lg:w-full flex-col my-6  items-center z-10">
        <div className="flex flex-1 flex-col lg:flex-row items-center text-center lg:items-start lg:text-start">
          <div className="flex flex-row items-center gap-6">
            {voiceStore.step1Values.image ? (
              <img
                src={URL.createObjectURL(voiceStore.step1Values.image)}
                className="w-[100px] h-[100px] rounded-full"
                alt="Profile"
              ></img>
            ) : (
              <img
                src={UserThumb}
                className="w-[100px] h-[100px] rounded-full"
                alt="Profile"
              ></img>
            )}
          </div>
          <div className="w-[1px] h-2/3 bg-[#DDE1E6] mx-12"></div>

          <div className="flex flex-1 flex-col ">
            <span className="text-4xl font-semibold text-[#21272A] mb-2">
              {voiceStore.step1Values.talentName
                ? voiceStore.step1Values.talentName
                : "-"}
            </span>

            <span className="text-base font-normal text-[#21272A]">
              Mobile :{" "}
              {voiceStore.step1Values.mobileNo
                ? voiceStore.step1Values.mobileNo
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              E-mail :{" "}
              {voiceStore.step1Values.email
                ? voiceStore.step1Values.email
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              Age :{" "}
              {voiceStore.step1Values.dob
                ? this.calculateAge(voiceStore.step1Values.dob)
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              Social Accounts :{" "}
              {voiceStore.step1Values.socialAccounts
                ? voiceStore.step1Values.socialAccounts
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              Nationality :{" "}
              {voiceStore.step1Values.nationality
                ? voiceStore.step1Values.nationality
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              Accents :{" "}
              {voiceStore.step1Values.accents
                ? voiceStore.step1Values.accents
                    .map((accent) => accent.value)
                    .join(",")
                : "-"}
            </span>
            <span className="text-base font-normal text-[#21272A]">
              Notes :{" "}
              {voiceStore.step1Values.notes
                ? voiceStore.step1Values.notes
                : "-"}
            </span>
            <div className="flex flex-row justify-center items-center lg:justify-start">
              <span className="text-base font-normal text-[#21272A]">
                Rating :{" "}
              </span>
              <Rating
                className="mt-[2px] ml-[2px]"
                emptySymbol={<FaRegStar size={15} />}
                fullSymbol={<FaStar size={15} />}
                halfSymbol={<FaStarHalfAlt size={15} />}
                fractions={2}
                readonly
                initialRating={
                  voiceStore.step1Values.rating
                    ? voiceStore.step1Values.rating
                    : 0
                }
              />
            </div>
          </div>
        </div>

        <div className="mt-12 w-full">
          {voiceStore.step2Values.files.length > 0 && (
            <table className="flex flex-1 flex-col shrink-0 w-full bg-transparent border text-left border-[#DDE1E6]">
              <thead className="flex flex-1">
                <tr className="bg-[#E8E9ED] flex flex-1 flex-row justify-between">
                  <th className="flex-1 font-normal text-xs lg:text-sm text-[#121619] p-3">
                    Name
                  </th>
                  <th className="flex-1 font-normal text-xs lg:text-sm text-[#121619] p-3">
                    Tags
                  </th>
                </tr>
              </thead>
              <tbody>
                {voiceStore.step2Values.files.map((file, index) => (
                  <tr
                    key={index}
                    className="border-b border-[#DDE1E6] flex flex-1 flex-row justify-around "
                  >
                    <td className="p-4 flex flex-1 items-center gap-x-4">
                      <div>
                        {file?.fileType.includes("audio") ? (
                          <>
                            <button
                              onClick={() => this.handlePlayPause(index)}
                              className="text-xl"
                            >
                              {this.state.currentPlayingIndex === index &&
                              !this.audioRefs[index].paused ? (
                                <LuPause></LuPause>
                              ) : (
                                <LuPlay></LuPlay>
                              )}
                            </button>
                            <audio ref={(ref) => (this.audioRefs[index] = ref)}>
                              <source
                                src={URL.createObjectURL(file.voiceFile)}
                              />
                            </audio>
                          </>
                        ) : (
                          <button
                            onClick={() => {
                              voiceStore.setVideoModal({
                                fileName: file.fileName,
                                video: URL.createObjectURL(file.voiceFile),
                              });
                            }}
                            className="text-xl"
                          >
                            <LuPlaySquare></LuPlaySquare>
                          </button>
                        )}
                      </div>

                      <span className="font-normal text-sm text-[#21272A]">
                        {file.fileName}
                      </span>
                    </td>

                    <td className="p-4 flex flex-1  flex-wrap justify-between items-center">
                      <div className="flex flex-1  flex-wrap gap-2">
                        {file.tags.gender?.value && (
                          <span
                            key={file.tags.gender.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {file.tags.gender.label}
                          </span>
                        )}
                        {file.tags.languages.map((tag) => (
                          <span
                            key={tag.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {tag.label}
                          </span>
                        ))}

                        {file.tags.accents.map((tag) => (
                          <span
                            key={tag.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {tag.label}
                          </span>
                        ))}
                        {file.tags.ageGroups.map((tag) => (
                          <span
                            key={tag.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {tag.label}
                          </span>
                        ))}
                        {file.tags.styles.map((tag) => (
                          <span
                            key={tag.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {tag.label}
                          </span>
                        ))}

                        {file.tags.additionalTags.map((tag) => (
                          <span
                            key={tag.value}
                            className="font-normal text-[10px] lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md"
                          >
                            {tag.label}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="mt-14 flex justify-end gap-2 pb-10">
          <button
            className="text-[#130D0D] font-medium text-base px-6 py-2 rounded-md border-[2px] border-[#130D0D]"
            onClick={() => {
              voiceStore.prevStep();
            }}
          >
            Back
          </button>
          <button
            disabled={loading}
            className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D]"
            onClick={async () => {
              this.setState({ loading: true });
              await voiceStore
                .createTalent()
                .then((data) => {
                  voiceStore.changeStepperVisible(false);
                  this.setState({ loading: false });
                })
                .catch((error) => {
                  this.setState({ loading: false });

                  console.error("Error creating profile:", error);
                });
            }}
          >
            {!loading && "Save"}
            <Bars
              height="25"
              width="25"
              color="#F89A1F"
              ariaLabel="bars-loading"
              visible={loading}
            />
          </button>
        </div>
      </div>
    );
  }
}
